<template>
    <PopoverRight ref="popoverChannel" width="650px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">新增推广渠道</h1>
            <p class="remain-title" v-if="remainNum.count">还剩{{remainNum.count || 0}}个分机号可用</p>
            <el-form class="form-container" :model="formList" :rules="formRules" ref="channelFormRef">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">推广渠道</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="name">
                            <el-select placeholder="请选择推广渠道" class="input-control" v-model="formList.name">
                                <el-option v-for="item in typeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">400号码</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item>
                            <el-select placeholder="请选择400号码" class="input-control" v-model="formList.mobile" @change="onChange">
                                <template  v-for="item in mobileList" >
                                    <el-option  :key="item.id" :value="item.id" :label="item.hotline_number"></el-option>

                                    <!-- <template v-if="item.only_user_400 == 0">
                                        <el-option :disabled="item.enable==0 ? true : false"   :key="item.id" :value="item.id" :label="item.hotline_number"></el-option>
                                    </template>
                                    <template v-if="item.only_user_400==1">
                                        <el-option :disabled="item.enable==0 ? true : false "   :key="item.id" :value="item.id" :label="item.hotline_number+ ' ( 直拨号 )'"></el-option>
                                    </template> -->
                                </template>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">分机号</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="telephone_number">
                            <el-input :placeholder="fjTips"  v-model="formList.telephone_number" type="number" style="width:400px;"></el-input>
                            <span class="random" @click="getRandom()">系统随机</span>
                        </el-form-item>
                    </div>
                </div>
                <div class="align-center">
                    <el-button @click="hideMenu">取消</el-button>
                    <el-button type="primary" @click="submitForm" :disabled="disabled">提交</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import { getInvesHotlineNum, getInvesHotline, getRandomHotline } from '@/service/investment'
import { getFormChannels } from '@/service/investment'
import { mapGetters } from 'vuex'
export default {
    name: 'AddChannel',
    components: {
        PopoverRight
    },
    props: {
        callback: Function,
        size: Number,
        house_id:Number
    },
    data () {
        return {
            formList: {
                name: '',
                mobile: '',
                telephone_number:''
            },
            formRules: {
                name: [
                    { required: true, message: '请选择推广渠道', trigger: 'change' }
                ],
                mobile: [
                    { required: true, message: '请选择400号码', trigger: 'change' }
                ],
                telephone_number: [
                    { required: true, message: '分机号不能为空', trigger: 'blur' }
                ]
            },
            remainNum: {},
            typeList: [],
            mobileList: [],
            condition: {
                page: 1,
                per_page: 10
            },
            channelArr:[],
            fjTips:"请输入6位的分机号”，6位所选400号码的分机号位数",
            randomNum:'',
            telephoneLen:'',
        }
    },
    computed: {
        disabled () {
            return !this.remainNum.count || this.remainNum.count <= 0
        }
    },
    mounted () {
       
      
    },
    methods: {
        /** 400选择触发 */
        onChange (value) {
            let row = this.mobileList.filter(item => {
                        if (item.id == value ) return item
                    })
            this.telephoneLen = row[0].telephone_length;
            this.fjTips = "请输入"+row[0].telephone_length+"位分机号,"+row[0].telephone_length+"位所选400号码的分机号位数"

            this.getRemainNum()
            this.getRandomNumber();
            
        },
        /** 获取随机分机号分机号 */
        async getRandomNumber () {
            try {
              const res = await getRandomHotline()
              this.formList.telephone_number = res.telephone_number
            } catch (error) {
                
            }
        },
        getRandom(){ //系统随机
            this.getRandomNumber();
        },

        /** 获取剩余分机号 */
        async getRemainNum () {
            try {
              const res = await getInvesHotlineNum(this.formList.mobile, {
                  customerHotlineId: this.formList.mobile,
                  site_id: this.permission_siteId
              })
              this.remainNum = res
            } catch (error) {
                this.remainNum = {}
            }
        },
        /** 获取推广渠道列表 */
        async initTypeList () {
            try {
                const res = await getFormChannels()
                let data = res;
                if(this.channelArr.length){
                    this.channelArr.filter(item =>{
                        data.forEach((el,index) => {
                            if(item == el.id ){
                                data.splice(index,1)
                            }
                        })
                    })
                }
                if(this.channelList.length){
                    for(let i in this.channelList){
                        for(let a in data){
                            if(data[a].id == this.channelList[i].channel){
                                data.splice(a,1)
                            }
                        }
                    }
                }
                this.typeList = data
            } catch (error) {
                const message = error.message
                this.$message({
                    type: 'error',
                    message: message || '初始化推广列表失败'
                })
            }
        },
        /** 获取400列表 */
        async initMobileList () {
            try {
                const res = await getInvesHotline()
                this.mobileList = res;
            } catch (error) {
                const message =error.message
                this.$message({
                    type: 'error',
                    message: message || '初始化400列表失败'
                })
            }
        },
        /** 打开右侧悬浮层 */
        openMenu () {
            this.$refs.popoverChannel && this.$refs.popoverChannel.open()
            this.initTypeList();
            this.initMobileList()
            this.$refs.channelFormRef && this.$refs.channelFormRef.clearValidate()
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.resetForm()
            this.$refs.popoverChannel && this.$refs.popoverChannel.hide()
            this.$refs.channelFormRef && this.$refs.channelFormRef.clearValidate()
        },
        resetForm () {
            this.formList = {
                name: '',
                mobile: '',
                telephone_number:''
            }
            this.fjTips ="请输入4位分机号"
            this.remainNum = {}
        },
        submitForm () {
            this.$refs.channelFormRef.validate(valid => {
                if (!valid) return null
                if(this.formList.telephone_number.length != this.telephoneLen){
                        this.$message({
                        type: 'error',
                        message: '请输入'+this.telephoneLen+'位分机号'
                    })
                    return null
                }
                const channel = this.typeList.find(v => v.id === this.formList.name)
                for(let i in this.typeList){
                    if(this.typeList[i].id == this.formList.name){
                        this.typeList.splice(i,1)
                    }
                }
                let row = this.mobileList.filter(item => {
                        if (item.id == this.formList.mobile ) return item
                    })
                const data = {
                    hotline_id: this.formList.mobile,
                    customer_hotline_id: this.formList.mobile,
                    hotline_number: row[0].hotline_number,
                    telephone_number:this.formList.telephone_number,
                    channel: channel.id,
                    channel_name: channel.name,
                    bind_status:0
                }
                this.callback(data)
                this.hideMenu()
            })
        },
    }
}
</script>
<style scoped>
.remain-title{
    color: red;
    font-size: 13px;
    padding-top: 10px;
    opacity: 0.8;
}
.grey{
    color:#c0c4cc!important;
}
.random{
    margin-left:20px;
    cursor: pointer;
    font-size:16px;
}
</style>